import constants from "../constants";
import httpService from "./httpService";
import utils from "./utils";

export default {
  getUserSigned(stepId) {
    return httpService.get("attachment/signatureTokenInfo", {
      params: { stepId: stepId }
    });
  },

  findAll(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    var params = utils.merge(example, pageable);
    return httpService.get("attachment", { params: params });
  },

  findAllByTask(taskId, example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      { taskId: taskId },
      utils.merge(example, pageable)
    );
    return httpService.get("attachment/findAllByTask", { params: params });
  },

  findAllByBook(bookDocId, example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(
      { bookDocId: bookDocId },
      utils.merge(example, pageable)
    );
    return httpService.get("attachment/findAllByBook", { params: params });
  },

  delete(id) {
    return httpService.delete("attachment/" + id);
  },

  findAllByComments(commentIds, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge({ commentIds: commentIds }, pageable);
    return httpService.get("attachment/findAllByComments", { params: params });
  },

  getPageSize(attachmentId) {
    return this.getAttachmentMetadata(attachmentId);
  },

  getAttachmentMetadata(attachmentId) {
    return httpService.get("attachment/getAttachmentMetadata", {
      params: { vbAttachmentId: attachmentId }
    });
  },

  getPageSizeComment(attachmentMetaId) {
    return httpService.get("attachment/getAttachmentMetadataComment", {
      params: { attachmentMetaId: attachmentMetaId }
    });
  },

  uploadImageDoc(params) {
    return httpService.post("attachment/uploadImageComment2", params);
  },

  uploadFileComment(params) {
    return httpService.post("attachment/uploadFileComment", params);
  },

  // Upload file trả về url
  uploadFileAll(params) {
    return httpService.post("attachment/uploadFileAll", params);
  },

  findReferenceOutgoingAttachment(docId) {
    return httpService.get("attachment/findReferenceOutgoingAttachment", {
      params: { docId: docId }
    });
  },

  getListUserSigned(flowInstanceId) {
    return httpService.get("attachment/signatureInfo", {
      params: { flowInstanceId: flowInstanceId }
    });
  },

  getStampInfo(flowInstanceId) {
    return httpService.get("attachment/stampInfo", {
      params: { flowInstanceId: flowInstanceId }
    });
  },

  findTrangKySo(outgoingDocId) {
    return httpService.get("attachment/findTrangKySo/" + outgoingDocId);
  },

  uploadSignedPdf(docId, objectType, base64) {
    return httpService.post("vbAttachment/uploadSignedPdf", {
      docId: docId,
      objectType: objectType,
      base64: base64
    });
  },

  getHashSignViettel(docId, certUserBase64, tokenImage, base64String) {
    return httpService.post("sign-token-viettel/getHash/" + docId, {
      certUserBase64,
      tokenImage,
      base64String,
    }, { baseURL: constants.BASE_SIGN_SERVICE_URL });
  },

  loginSCA(params) {
    return httpService.post("auth/token", {}, {
      params,
      baseURL: "https://rmgateway.vnptit.vn/auth/authorize"
    });
  },

  getTokenSCA(params) {
    return httpService.post("mobileCA/getSmartCAToken", {}, {
      params
    });
  },

  signFileSCA(data) {
    return httpService.post("mobileCA/signFile", data);
  },

  signFileWithPassword(data) {
    return httpService.post("mobileCA/signFileWithPassword", data);
  },

  signFileWithPasswordIntrust(data){
    return httpService.post("/mobileCA/signFileWithPasswordIntrustCA", data)
  },

  loginIntrustCA(data) {
    return httpService.post("/mobileCA/loginIntrustCA", data)
  },

  getCertificates(data) {
    return httpService.post("/mobileCA/getCertificates", data)
  },

  signFileWithPasswordIntrustCaNew(data) {
    return httpService.post("/mobileCA/signFileWithPasswordIntrustCaNew", data)
  },

  signFileWithPasswordIntrustCAV2(data) {
    return httpService.post("/mobileCA/signFileWithPasswordIntrustCAV2", data)
  },

  uploadSignedAttachment(docId, base64String) {
    return httpService.post("attachment/uploadSignedAttachment", {
      docId,
      base64String,
    });
  },

  addImageToFile(docId, base64String, insertImage) {
    return httpService.post("sign-token-viettel/addImage/" + docId, {
      insertImage,
      base64String,
    }, { baseURL: constants.BASE_SIGN_SERVICE_URL });
  },

  signViettel(docId, signatureBase64, tokenImage, base64String) {
    return httpService.post("sign-token-viettel/sign/" + docId, {
      signatureBase64: signatureBase64,
      tokenImage,
      base64String
    }, { baseURL: constants.BASE_SIGN_SERVICE_URL });
  },

  cloneFromTask(taskId) {
    return httpService.post("vbAttachment/cloneFromTask", null, {
      params: { taskId: taskId }
    });
  },

  findAllByHcCalendar(hcCaseMasterId) {
    return httpService.get("vbAttachment/findAllByHcCalendar", {
      params: { hcCaseMasterId: hcCaseMasterId }
    });
  },

  deleteHcCalendarFile(id, hcCaseCalendarId) {
    return httpService.delete(`vbAttachment/${id}/deleteHcCalendarFile`, {
      params: { hcCaseCalendarId: hcCaseCalendarId }
    });
  },

  findAllByHcCaseFlightId(hcCaseFlightId, type) {
    let params = { hcCaseFlightId: hcCaseFlightId, type: type };
    return httpService.get("vbAttachment/findAllByHcCaseFlightId", {
      params: params
    });
  },

  findAllByHcCaseMasterId(hcCaseMasterId, type) {
    let params = { hcCaseMasterId: hcCaseMasterId, type: type };
    return httpService.get("vbAttachment/findAllByHcCaseMasterId", {
      params: params
    });
  },

  getNotify(data) {
    return httpService.post("/mobileCA/getNotify", data);
  },
};



// WEBPACK FOOTER //
// ./src/services/attachmentService.js